const myDelay = 7000;
const main = new Swiper('.fade.swiper', {
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  speed: 1000,
  autoplay: {
    delay: myDelay,
    disableOnInteraction: false,
    waitForTransition: false,
  },
});
const slide = new Swiper('.slide.swiper', {
  loop: true,
  loopAdditionalSlides: 2,
  slidesPerView: 2.5,
  spaceBetween: 20,
  speed: 6000,
  allowTouchMove: false,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
  },
  breakpoints: {
    960: {
      slidesPerView: 4,
      spaceBetween: 30,
    },
    1500: {
      slidesPerView: 5,
      spaceBetween: 30,
    },
    1800: {
      slidesPerView: 6,
      spaceBetween: 30,
    }
  },
});
const r2k = new Swiper('.swiper.r2k', {
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  loop: true,
  loopAdditionalSlides: 1,
  speed: 700,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
    waitForTransition: false,
  },
  followFinger: false,
});
const value = new Swiper('.swiper.value', {
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  loop: true,
  loopAdditionalSlides: 1,
  speed: 700,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
    waitForTransition: false,
  },
  followFinger: false,
});